import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DesktopEBookVMService } from 'modules/desktop/services/desktop-ebook-vm.service';
import { AppHelperService } from 'modules/app/services/app-helper.service';

declare var $: any;

@Component({
    selector: 'app-assignment-modal',
    styleUrls: ['./assignment-modal.style.scss'],
    templateUrl: './assignment-modal.template.html',
	standalone: false
})
export class AssignmentModal {

    selectedUserClass: any;
    @Input() assignableMaterialAvailable;
    @Input() isPplus;
    @Input() currentUserClasses;
    @Input() classId;
    @Input() spaceId;
    @Input() bundleId;
    @Input() bookId;
    @Input() currentPageLabel;
    @Input() showAssignmentLoader;
    @Output("publishAssignmentEvent") publishAssignmentEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output("closeAssignmentModal") closeAssignmentModal: EventEmitter<any> = new EventEmitter<any>();
    isEdgeCase: boolean = false;
    edgeCaseType: any; // 1 => No class; 2 => One class & No Material; 3 => Multiple Class & No Material     

    constructor(
        private desktopEBookVMService: DesktopEBookVMService,
        private appHelperService: AppHelperService,
    ) { }

    showAssignmentModal() {
        this.checkForEdgeCase();
        
        if (!this.selectedUserClass) {
            if (!this.classId) {
                this.selectedUserClass = this.currentUserClasses[0];
            } else {
                let userClass = this.currentUserClasses.find(userClass => userClass["uuid"] == this.classId);
                if (userClass) {
                    this.selectedUserClass = userClass;
                } else {
                    this.selectedUserClass = this.currentUserClasses[0];
                }
            }
        }

        let h = (window.innerHeight) / 2 - 84;
        $('.assignment-dropdown-menu').css("max-height", h);
        $('#assignmentModal').modal('show');
    }
    
    checkForEdgeCase() {
        if (this.currentUserClasses.length === 0) {
            this.isEdgeCase = true;
            this.edgeCaseType = 1;
            return;
        }

        if (!this.assignableMaterialAvailable) {
            this.isEdgeCase = true;
            if (this.currentUserClasses.length === 1) {
                this.edgeCaseType = 2;
            } else {
                this.edgeCaseType = 3;
            }
        }
    }

    /*
        function to navigate teacher from ebook to assignment section
     */
    navigateFromFoc() {
        // Emit event to student book component to publish assignment event
        this.publishAssignmentEvent.emit(); 
        $('#assignmentModal').modal('hide');
        
        // sync with server and reset vm
        this.desktopEBookVMService.syncLocalWithServer(true);
        this.desktopEBookVMService.resetVM();

        let options = {
            queryParams: {
                fwd: true,
                spaceId: this.spaceId,
                classId: this.classId,
                bookId: this.bookId,
                bundleId: this.bundleId,
                currentPageLabel: this.currentPageLabel,
                isPplus: this.isPplus
            },
            isEdgeCase: false,
            edgeCaseType: null
        }

        if (this.isEdgeCase) {
            options.isEdgeCase = this.isEdgeCase; 
            options.edgeCaseType = this.edgeCaseType;
            if (!this.selectedUserClass) {
                this.selectedUserClass = {
                    customSpaceKey: undefined
                }
            }
        }

        setTimeout(() => {
            this.appHelperService.navigateFromAssignmentModal(this.selectedUserClass['customSpaceKey'], this.selectedUserClass.uuid, options);
        }, 150);
    }


    /**
     * This function is used to handle keyboard events for close and action button
     * - If tab is pressed on close button, focus should go on action button
     * - If shift+tab is pressed on action button, focus should go on close button
     * @param event - Keyboard event
     * @param button - button name
     */
    handleKeyDown(event:any , button:string) {
        const closeBtn = document.getElementById('assignmentModalCloseBtn');
        const actionBtn = document.getElementById('assignmentModalActionBtn');
        if (event.key === 'Tab') {
            switch (button) {
                case 'actionBtn':
                    if(!event.shiftKey) {
                        event.preventDefault();
                        closeBtn.focus();
                    }
                    break;
                case 'closeBtn':
                    if(event.shiftKey) {
                        event.preventDefault();
                        actionBtn.focus();    
                    }
                    break;
                }
        }
    }

    /**
     * This function is used to handle keyboard events for dropdown
     * - If enter or space is pressed on dropdown, it should select dropdown item
     * @param event - Keyboard event
     */
    handleDropdownKeyDown(event: any) {
        if(event.key === 'Enter' || event.key === 'Spacebar' || event.key === ' ') {
            event.preventDefault();
            event.target.click();
        }
    }

    /**
     * This function is used to emit event of closing assignment modal
     */
    closeModal() {
        this.closeAssignmentModal.emit();
    }
}